export default "__VITE_ASSET__pstUxE94__"